// extracted by mini-css-extract-plugin
export default {"wrapper":"NoteExpertGeneralPageSliderMobile_wrapper__E9M0c","list":"NoteExpertGeneralPageSliderMobile_list__ib+kb","buttons":"NoteExpertGeneralPageSliderMobile_buttons__-Z3bq"};